module.exports = __webpack_public_path__ + "media/application/images/not-found-7481489f8fcb325fc4aed73a8bc2ea5a.png";